import * as S from "./Loading.style";

export const Loading = () => {
  return (
    <S.LoadingBox>
      <S.Loading />

      <S.LoadingTxt>LOADING...</S.LoadingTxt>
    </S.LoadingBox>
  );
};
